import React from 'react';
import Ribbon from '../Ribbon/Ribbon';
import logo from '../../images/header/logo.svg';
import s from './Hero.module.css';

export default function Hero({ title, sendUrl }) {
  const url = sendUrl;
  return (
    <div
      style={{
        backgroundImage: `url(${url})`,
      }}
      className={s.wrapper}
    >
      <Ribbon />

      <div
        style={{
          width: '100%',

          margin: 'auto',
        }}
      >
        <div className={s.contentWrapper}>
          <div className={s.heroContent}>
            <img src={logo} alt={'logo'} />
            <h1 className={s.heroTitle}> {title}</h1>
          </div>
        </div>
      </div>
    </div>
  );
}
